// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__1QVde","Box":"Navbar_Box__3K9Yx"};